export var PriceMedium = {
  lg: '32px',
  xs: '24px'
};